module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0005"
    }
  }, [_c('strong', [_vm._v("Section One")]), _c('br'), _vm._v("Truckbox Al’s Big Break")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Section Two")]), _c('br'), _vm._v("The Full Scholarship Orphaned Genius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Section Three")]), _c('br'), _vm._v("The Little Box Social")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Section Four")]), _c('br'), _vm._v("Bob Feller, Hal Newhouser, and Joe DiMaggio Himself")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4184cab2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0